import { FC } from 'react';
import { ReviewStarSpriteIcon } from './search-svg-sprite';

interface SearchRatingProps {
  stars?: number;
  count: number;
}

export const SearchRating: FC<SearchRatingProps> = ({ stars = 0, count }) => (
  <div className="bsn">
    <span>{stars.toFixed(1)}</span>
    <ReviewStarSpriteIcon width={16} height={16} />
    <span>({count})</span>
  </div>
);
